import { useEffect, useRef } from "react";
import { Howl } from "howler";
import { api } from "../../lib/api";
import { getLocalVolume } from "../../lib/soundBus";

export default function AmbientMusicPlayer({ scene, masterVolume = 0.6, combatOverrideUrl }) {
  const howlRef = useRef(null);
  const currentUrlRef = useRef(null);

  // Free Roam can have several simultaneous encounters — only the players actually IN an active
  // encounter's initiative order get battle music, purely client-side, without hijacking the
  // shared scene track for everyone else still exploring peacefully.
  const effectiveUrl = combatOverrideUrl || scene?.music_asset_url;

  useEffect(() => {
    const url = effectiveUrl;
    if (url === currentUrlRef.current) return;
    const prev = howlRef.current;
    if (prev) {
      prev.fade(prev.volume(), 0, 1200);
      setTimeout(() => prev.unload(), 1300);
    }
    currentUrlRef.current = url;
    if (!url) {
      howlRef.current = null;
      return;
    }
    const howl = new Howl({ src: [url], loop: true, volume: 0 });
    howl.play();
    howl.fade(0, masterVolume * getLocalVolume(), 1200);
    howlRef.current = howl;
    return () => {};
  }, [effectiveUrl]);

  useEffect(() => {
    if (howlRef.current) howlRef.current.volume(masterVolume * getLocalVolume());
  }, [masterVolume]);

  return null;
}
